import { render, staticRenderFns } from "./LogoFleetbeacon.vue?vue&type=template&id=537915f3&"
import script from "./LogoFleetbeacon.vue?vue&type=script&lang=js&"
export * from "./LogoFleetbeacon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports